export const isEmptyArray = (array) => {
    if (!array) return undefined;
    if (!Array.isArray(array)) return undefined;
    return array.length <= 0;
};

export const isValidArray = (array, allowEmpty = true) => {
    if (!array) return false;
    if (!Array.isArray(array)) return false;
    return allowEmpty ? true : array.length > 0;
};



// WEBPACK FOOTER //
// ./src/utils/arrays.js